export const LOADING = "LOADING";
export const AVAILABILITY_SLOTS = "AVAILABILITY_SLOTS";
